import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { randomID } from '@shared/utils/utils';
import { Modal } from 'bootstrap-italia';
import {
  IGenericModalConfirm,
  ModalSizeEnum,
} from 'src/app/model/generic-modal-confirm.model';
import { MessageManagerMessageTypeEnum } from 'src/app/shared/services/messages/message.manager.service';

@Component({
  selector: 'app-generic-modal-confirm',
  templateUrl: './generic-modal-confirm.component.html',
  styleUrls: ['./generic-modal-confirm.component.scss'],
})
export class GenericModalConfirmComponent implements AfterViewInit {
  private _modalConfig: IGenericModalConfirm = {
    id: randomID(),
    size: ModalSizeEnum.MEDIA,
    type: MessageManagerMessageTypeEnum.INFO,
    confirm: true,
    staticBackdrop: true,
    needIcon: false,
    crossDismissable: true,
    crossDismissableListen: true,
    onDismissBtnLabel: 'DISMISS',
    messageFontSize: '18px',
    onDismiss: () => this.closeModal(false),
    closeBtnDisabled: false
  };
  randomId = '';

  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('genericModal') genericModal!: ElementRef;
  @ViewChild('modalTitleRef') modalTitleRef!: ElementRef;
  @Input() set modalConfig(modalConfig: IGenericModalConfirm) {
    this._modalConfig = Object.assign(modalConfig, {
      ...this._modalConfig,
      ...modalConfig,
    });
    if(modalConfig.customSize){
      this._modalConfig.size = undefined;
    }
  }

  MessageManagerMessageTypeEnum = MessageManagerMessageTypeEnum;

  constructor() {
    this.randomId = this._randomId();
  }

  closePressed: boolean = false;

  modal: Modal | undefined;

  ngAfterViewInit(): void {
    if (this.modalTitleRef) {
      this.modalTitleRef.nativeElement.focus();
      this.modalTitleRef.nativeElement.tabIndex = -1;
    }
  }

  get modalConfig() {
    return this._modalConfig;
  }

  showModal() {
    const modalRef = document.getElementById(this.modalConfig!.id);
    if (
      !modalRef?.classList.contains('show') &&
      modalRef?.classList.contains('fade') &&
      !this.modal
    ) {
      this.modal = new Modal(modalRef, { backdrop: 'static' });
      this.modal.show();
      modalRef.addEventListener('shown.bs.modal', () => {
        if (this.genericModal) {
          this.genericModal.nativeElement.setAttribute('role', this.modalRole);
        }
      });
      modalRef.addEventListener('hidden.bs.modal', () => {
        this.closeEvent.emit(this.closePressed);
      });
    } else if(this.modal){
      this.modal.show();
    }
  }

  closeModal(state: boolean = false) {
    this.closePressed = state
    this.modal?.hide();
  }

  isOpen() {
    const modalRef = document.getElementById(this.modalConfig?.id);
    return this.modalConfig && modalRef && modalRef.classList.contains('show');
  }

  /**
   * generate ID RANDOM
   */
  private _randomId() {
    return Math.random().toString(36).slice(2);
  }

  get modalRole(): string {
    return this.modalConfig &&
      this.modalConfig.type &&
      (this.modalConfig.type == this.MessageManagerMessageTypeEnum.DANGER ||
        this.modalConfig.type == this.MessageManagerMessageTypeEnum.WARNING)
      ? 'alertdialog'
      : 'dialog';
  }
}
